"use client";
import React, { useEffect, useState } from "react";
import { DeliveryOrderModal } from "./deliveryOrderModal";
import {
  getFromLocalStorage,
  saveToLocalStorage,
} from "@/utils/localStorageUtils";
import { LocalStorageKey } from "@/utils/storageKeys";
import { OrderType } from "@/constants/enum";
import { useNativeActions } from "@/utils/useNativeActions";
import { useMerchantColor } from "@/utils/hooks/useMerchantColor";
import { Merchant } from "@/dto/merchant";

interface OnloadPopUpProps {
  merchant: Merchant;
  orderType?: OrderType | string;
}

export const OnloadPopUp = ({ merchant, orderType }: OnloadPopUpProps) => {
  const merchantColor = useMerchantColor()
  const { isCmaApp } = useNativeActions();
  const isPopupTouched = getFromLocalStorage<boolean>(
    LocalStorageKey.NEWCOLO_ONLOADPOP_ISTOUCHED,
    false
  );
  const [isTouched, setIsTouched] = useState(!!isPopupTouched);
  const [isPreview, setIsPreview] = useState<boolean>(false);

  useEffect(() => {
    setIsPreview(globalThis.location.hostname.startsWith("preview-"));
  }, []);

  const closeModal = () => {
    const existingFlag = Boolean(isPopupTouched);
    saveToLocalStorage(
      LocalStorageKey.NEWCOLO_ONLOADPOP_ISTOUCHED,
      !existingFlag
    );
    setIsTouched(!existingFlag);
  };

  if (
    isTouched ||
    isPreview ||
    orderType?.toLowerCase() === OrderType.DINE_IN.toLowerCase() ||
    isCmaApp
  )
    return null;

  return (
    <DeliveryOrderModal
      onRequestClose={closeModal}
      merchant={merchant}
      merchantColor={merchantColor}
    />
  );
};
